import React from 'react'
import injectStyles from 'react-jss'

import { Fab, Grid, Paper } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { styles } from './styles'

const StartSequence = ({ classes, handleDrawerToggle, isNamed }) => {
  if (isNamed) {
    return (
      <Grid container direction="column" alignItems="center">
        <Grid item xs>
          <Paper className={classes.wrap} elevation={4}>
            Should your new sequence be activated by Trigger or a Scheduled
            date?
          </Paper>
        </Grid>
        <Grid item xs>
          <div className={classes.line} />
        </Grid>
        <Grid item xs>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => handleDrawerToggle(true)}
          >
            <AddIcon />
          </Fab>
        </Grid>
      </Grid>
    )
  } else {
    return (
      <Grid container direction="column" alignItems="center">
        <Grid item xs>
          <Paper className={classes.wrap} elevation={4}>
            First you need to create a name for the sequence.
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default injectStyles(styles)(StartSequence)
